const href = '//crossjewellia.co.jp/cdn/shop/t/209/assets/AddPhone.css?v=64594254122398534551786076918';
const link = document.createElement('link');
link.rel = 'stylesheet';
link.href = href;
document.head.appendChild(link);

function createShopInfo(shopData) {
  const shopsContainer = document.createElement('div');
  shopsContainer.classList.add('shops-container');
  shopsContainer.setAttribute('id', 'store' + shopData.num);

  const shopsContentContainer = document.createElement('div');
  shopsContentContainer.classList.add('shops-content-container');

  const shopsImageContainer = document.createElement('div');
  shopsImageContainer.classList.add('shops-image-container');

  const img = document.createElement('img');
  img.src = shopData.imageSrc;
  img.alt = shopData.shopName.replace(/<[^>]*>/g, '');
  shopsImageContainer.appendChild(img);

  const h2 = document.createElement('h2');
  h2.classList.add('storeListTitle');
  h2.innerHTML = shopData.shopName;

  const p = document.createElement('p');
  p.innerHTML = `${shopData.address} <br> ${shopData.hours}`;
  shopsContentContainer.appendChild(p);

  const positionText = document.createTextNode(shopData.position);
  shopsContentContainer.appendChild(positionText);

  // アコーディオンの作成
  const accordionContainer = document.createElement('div');
  accordionContainer.classList.add('accordion-container');

  // アコーディオンタイトル
  const accordionTitle = document.createElement('button');
  accordionTitle.classList.add('accordion');
  accordionTitle.innerHTML = '店舗限定サービスを見る';

  accordionTitle.onclick = function () {
    this.classList.toggle('active');
    const panel = this.nextElementSibling;

    if (panel.style.maxHeight && panel.style.maxHeight !== '0px') {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = 'auto';
      const fullHeight = panel.scrollHeight;
      panel.style.maxHeight = '0px';
      setTimeout(() => {
        panel.style.maxHeight = (fullHeight + 20) + 'px';
      }, 0);
    }
  };

  // アコーディオン内のコンテンツ
  const accordionContent = document.createElement('div');
  accordionContent.classList.add('panel');
  accordionContent.style.maxHeight = '0';
  accordionContent.style.overflow = 'hidden';

  const additionalDetails = document.createElement('p');
  additionalDetails.classList.add('ptxtp');
  additionalDetails.innerHTML = shopData.acTxt;
  accordionContent.appendChild(additionalDetails);

  accordionContainer.appendChild(accordionTitle);
  accordionContainer.appendChild(accordionContent);

  shopsContentContainer.appendChild(accordionContainer);

  // 境界線
  const accordionBorder = document.createElement('div');
  accordionBorder.classList.add('panelBorder');
  shopsContentContainer.appendChild(accordionBorder);

  // ボタンエリア
  const additionalInfo = document.createElement('div');
  additionalInfo.classList.add('additional-info');

  // Instagramリンク
  const instagramButton = document.createElement('a');
  instagramButton.href = shopData.instagram;
  instagramButton.classList.add('instagram-button', 'shop_insta');
  instagramButton.target = '_blank';
  instagramButton.rel = 'noopener noreferrer';

  const instagramIcon = document.createElement('img');
  instagramIcon.src = '//crossjewellia.co.jp/cdn/shop/t/209/assets/insta.png?v=3847125336139491241786076960';
  instagramIcon.alt = 'Instagram Icon';
  instagramIcon.style.marginRight = '10px';
  instagramIcon.style.fontSize = '1.5rem';
  instagramIcon.style.fontFamily = "'Jost', sans-serif";
  instagramIcon.style.whiteSpace = 'nowrap';

  instagramButton.appendChild(instagramIcon);
  instagramButton.appendChild(document.createTextNode('INSTAGRAM'));
  additionalInfo.appendChild(instagramButton);

  // マップリンク
  const mapButton = document.createElement('a');
  mapButton.href = shopData.mapLink;
  mapButton.classList.add('map-button');
  mapButton.target = '_blank';
  mapButton.rel = 'noopener noreferrer';

  const mapIcon = document.createElement('img');
  mapIcon.src = '//crossjewellia.co.jp/cdn/shop/t/209/assets/iia_maps.png?v=63695185546016630041786076960';
  mapIcon.alt = 'Map Icon';
  mapIcon.style.marginRight = '10px';
  mapIcon.style.fontSize = '1.5rem';
  mapIcon.style.whiteSpace = 'nowrap';

  mapButton.appendChild(mapIcon);
  mapButton.appendChild(document.createTextNode('STORE MAP'));
  additionalInfo.appendChild(mapButton);

  shopsContentContainer.appendChild(additionalInfo);

  // ここで順番を変更
  // 画像 → h2 → コンテンツ
  // shopsContainer.appendChild(shopsImageContainer);
  // shopsContainer.appendChild(h2);
  // shopsContainer.appendChild(shopsContentContainer);

  const glayWrapper = document.createElement('div');
  glayWrapper.classList.add('glay-wrapper');

  glayWrapper.appendChild(shopsImageContainer);
  glayWrapper.appendChild(h2);
  glayWrapper.appendChild(shopsContentContainer);

  shopsContainer.appendChild(glayWrapper);
  
  document.getElementById('shopsBox').appendChild(shopsContainer);
}

const shop1 = {
    imageSrc: '//crossjewellia.co.jp/cdn/shop/t/209/assets/upd_fu.jpg?v=140802243404228309271789633729',
    shopName: 'MARK IS 福岡ももち店',
    address: '福岡県福岡市中央区地行浜2丁目2-1 2F',
    hours: 'OPEN 10:00~21:00',
    instagram: 'https://www.instagram.com/crossjewellia_fukuoka_markis/',
    mapLink: 'https://maps.app.goo.gl/noFTV7MySWKFBLc16',
    position: '',
    num: 1,
    acTxt: '・ジュエリーカスタマイズ・修理<br>・ジュエリーサイズ交換<br>・イヤリング・ピアス片耳販売<br>・ジュエリー洗浄サービス<br>・パーマネントジュエリーサービス<span style="font-size:0.9rem; color:#e81515;">（注※1）</span><br><span style="font-size:0.9rem;"><span style="color:#e81515;">※1ご希望の方はInstagramのDMにてお気軽にご相談ください。</span><br>※一部サービスや購入時期によっては有料でのご対応となります。<br>※サービスのご利用には会員登録が必須となります。<br>※洗浄サービスは、弊社製品のみ承っております。</span>'
};

const shop2 = {
    imageSrc: '//crossjewellia.co.jp/cdn/shop/t/209/assets/upd_kuma.jpg?v=30922846647367131786077014',
    shopName: '<span>COCOSA</span>熊本店',
    address: '熊本県熊本市中央区下通1丁目3-8 1F',
    hours: 'OPEN 11:00~20:00',
    instagram: 'https://www.instagram.com/crossjewellia_kumamoto_cocosa/',
    mapLink: 'https://maps.app.goo.gl/oVzSC8Lt2XToUorGA',
    position: '',
    num: 2,
    acTxt: '・ジュエリーカスタマイズ・修理<br>・ジュエリーサイズ交換<br>・イヤリング・ピアス片耳販売<br>・ジュエリー洗浄サービス<br><span style="font-size:0.9rem;">※一部サービスや購入時期によっては有料でのご対応となります。<br>※サービスのご利用には会員登録が必須となります。</span>'
};

const shop4 = {
    imageSrc: 'https://cdn.shopify.com/s/files/1/0582/2575/4206/files/miyazaki_ten_148392ac-a560-4820-bba6-c09d29055284.jpg?v=1776767513',
    shopName: 'アミュプラザ宮崎店',
    address: '宮崎県宮崎市老松2丁目2-22 うみ館 1F',
    hours: 'OPEN 10:00~20:00',
    instagram: 'https://www.instagram.com/crossjewellia_miyazaki_amu/',
    mapLink: 'https://maps.app.goo.gl/vAiy5Vb4vP7urQvC9',
    position: '',
    num: 3,
    acTxt: '・ジュエリーカスタマイズ・修理<br>・ジュエリーサイズ交換<br>・イヤリング・ピアス片耳販売<br>・ジュエリー洗浄サービス<br><span style="font-size:0.9rem;">※一部サービスや購入時期によっては有料でのご対応となります。<br>※サービスのご利用には会員登録が必須となります。</span>'
};

// const shop4 = {
//     imageSrc: 'https://cdn.shopify.com/s/files/1/0582/2575/4206/files/upd_miya_951f0bc5-1d47-4777-81e9-5cfc143dcc88.jpg?v=1775543752',
//     shopName: 'アミュプラザ宮崎店',
//     address: '<span style="color: red !important; padding-right:1rem; font-size:1rem;">＜店内移転の為一時閉店中＞ 今年4月15日リニューアル</span>',
//     hours: '宮崎県宮崎市老松2丁目2-22 うみ館 1F',
//     instagram: 'https://www.instagram.com/crossjewellia_miyazaki_amu/',
//     mapLink: 'https://maps.app.goo.gl/vAiy5Vb4vP7urQvC9',
//     position: '',
//     num: 3,
//     acTxt: '・ジュエリーカスタマイズ・修理<br>・ジュエリーサイズ交換<br>・イヤリング・ピアス片耳販売<br>・ジュエリー洗浄サービス<br><span style="font-size:0.9rem;">※一部サービスや購入時期によっては有料でのご対応となります。<br>※サービスのご利用には会員登録が必須となります。</span>'
// };

const shop5 = {
    imageSrc: '//crossjewellia.co.jp/cdn/shop/t/209/assets/upd_oit.jpg?v=67797846681721497651786077014',
    shopName: 'センテラス天文館店',
    address: '鹿児島県鹿児島市千日町1-1 2F',
    hours: 'OPEN 10:00~20:00',
    instagram: 'https://www.instagram.com/crossjewellia_kagoshima_ct/',
    mapLink: 'https://maps.app.goo.gl/6zpBsWvfwFFFd72G6',
    position: '',
    num: 4,
    acTxt: '・ジュエリーカスタマイズ・修理<br>・ジュエリーサイズ交換<br>・イヤリング・ピアス片耳販売<br>・ジュエリー洗浄サービス<br><span style="font-size:0.9rem;">※一部サービスや購入時期によっては有料でのご対応となります。<br>※サービスのご利用には会員登録が必須となります。</span>'
};

const shop3 = {
    imageSrc: '//crossjewellia.co.jp/cdn/shop/t/209/assets/upd_sen.jpg?v=183320058755071411011786077015',
    shopName: 'アミュプラザ大分店',
    address: '大分県大分市要町1-14 3F',
    hours: 'OPEN 10:00~20:00',
    instagram: 'https://www.instagram.com/crossjewellia_oita_amu/',
    mapLink: 'https://maps.app.goo.gl/BQ5JNhTc8MYNiYLK8',
    position: '',
    num: 5,
    acTxt: '・ジュエリーカスタマイズ・修理<br>・ジュエリーサイズ交換<br>・イヤリング・ピアス片耳販売<br>・ジュエリー洗浄サービス<br><span style="font-size:0.9rem;">※一部サービスや購入時期によっては有料でのご対応となります。<br>※サービスのご利用には会員登録が必須となります。</span>'
};

// 各ショップの情報を作成
createShopInfo(shop1);
createShopInfo(shop2);
createShopInfo(shop3);
createShopInfo(shop4);
createShopInfo(shop5);